/* LogsViewComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./LogsViewRenderer");

class LogsViewComponent extends EventEmitter {
    constructor(logger, gameEditor, state, io) {
        super();
        this._io = io;
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._workId = state.logId;
        this._logFeed = undefined;
        this._plan = undefined;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }
    whenModelIsReady() {
        return this._gameEditor.whenPlanIsReady().then(() => {
            this._plan = this._gameEditor.getPlan();
            this._logFeed = this._plan.startWorkLogElementFeed(this._workId);
            this._registerLogFeedListeners();
            return this._logFeed.whenInitialized();
        });
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerLogFeedListeners() {
        this._logFeed.on("ElementInitialized", (this._onLogAdded = this._onLogAdded.bind(this)));
        this._logFeed.on("ElementAdded", (this._onLogAdded = this._onLogAdded.bind(this)));
    }
    _unregisterLogFeedListeners() {
        if (this._logFeed) {
            this._logFeed.removeListener("ElementInitialized", this._onLogAdded);
            this._logFeed.removeListener("ElementAdded", this._onLogAdded);
        }
    }
    _registerListeners() {}
    _unregisterListeners() {
        this._unregisterLogFeedListeners();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get logFile() {
        return this.getLogFile();
    }
    getLogFile() {
        return this._logFile;
    }
    get plan() {
        return this.getPlan();
    }
    getPlan() {
        return this._plan;
    }
    get io() {
        return this._io;
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._logger = undefined;
        this._gameEditor = undefined;
        return Promise.resolve(prom).then(() => {
            if (this._logFeed) {
                return this._logFeed.shutdown();
            }
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onLogAdded(log) {
        this.emit("LogAdded", log);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }
    get logger() {
        return this._logger;
    }
    get workId() {
        return this.getLogId();
    }
    getLogId() {
        return this._workId;
    }
    get logFeed() {
        return this.getLogFeed();
    }
    getLogFeed() {
        return this._logFeed;
    }
    getLogs() {
        return this._logFeed.getCacheAsArray();
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = LogsViewComponent;
LogsViewComponent.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.viewState", "$teve.io"];
LogsViewComponent.$displayDetails = {
    type: "View",
    name: "Logs",
    icon: "common.edit",
    shown: false
};
